"use client";

import { useStyles } from "./styles";

interface PowerLevelItemProps {
  variant: "text" | "quality" | "speed" | "fandom";
  value: number;
}

const PowerLevelItem: React.FC<PowerLevelItemProps> = ({ variant, value }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.container}>
      <span className={classes.label}>{variant}</span>
      <div className={classes.bars}>
        {Array.from({ length: 5 }, (_, index) => {
          const active = index < value;

          return (
            <div
              className={cx(classes.bar, {
                [classes.textVariant]: variant === "text" && active,
                [classes.qualityVariant]: variant === "quality" && active,
                [classes.speedVariant]: variant === "speed" && active,
                [classes.fandomVariant]: variant === "fandom" && active,
              })}
              key={`level-${index + 1}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PowerLevelItem;
